import { api } from "../../../lib/axios";
import type { ClientApi, ContratApi } from "./types";

type ClientsListResponse = {
  data?: ClientApi[];
  meta?: { totalPages?: number };
};

export async function fetchAllClients(): Promise<ClientApi[]> {
  const all: ClientApi[] = [];
  let page = 1;
  let totalPages = 1;

  do {
    const res = await api.get<ClientsListResponse>("/clients", {
      params: { page, limit: 200 },
    });
    const chunk = Array.isArray(res.data?.data) ? res.data.data : [];
    all.push(...chunk);
    totalPages = Math.max(1, Number(res.data?.meta?.totalPages) || 1);
    page += 1;
  } while (page <= totalPages);

  return all;
}

export async function fetchContratsByClientIds(clientIds: number[]): Promise<Map<number, ContratApi[]>> {
  const map = new Map<number, ContratApi[]>();
  const BATCH = 14;

  for (let i = 0; i < clientIds.length; i += BATCH) {
    const slice = clientIds.slice(i, i + BATCH);
    await Promise.all(
      slice.map(async (id) => {
        try {
          const res = await api.get<ContratApi[]>(`/clients/${id}/contrats`);
          const arr = Array.isArray(res.data) ? res.data : [];
          map.set(id, arr);
        } catch {
          map.set(id, []);
        }
      })
    );
  }

  return map;
}
